import { createReducer } from 'typesafe-actions';

import { Bulletin, Link, Species } from '../../services/types';
import { loadBulletin, loadLinks, loadSpecies } from './speciesData.actions';

export interface SpeciesDataState {
  selectedSpeciesData?: Species;
  speciesData: Species[];
  selectedBulletin?: Bulletin[];
  bulletinData: Bulletin[];
  weblinksData: Link[]; 
}

export const speciesDataState: SpeciesDataState = {
  selectedSpeciesData: undefined,
  speciesData: [],
  selectedBulletin: undefined,
  bulletinData: [],
  weblinksData: []

};

export default createReducer<SpeciesDataState>(speciesDataState)
  .handleAction(
    loadSpecies.success,
    (state, action) => {
      return {
        ...state,
        speciesData: action.payload,
      };
    }
  )
  .handleAction(
    loadBulletin.success,
    (state, action) => {
      return {
        ...state,
        bulletinData: action.payload,
      };
    }
  )
  .handleAction(
    loadBulletin.failure,
    (state, action) => {
      return {
        ...state,
        bulletinData: [],
      };
    }
  )
  .handleAction(
    loadLinks.success,
    (state, action) => {
      return {
        ...state,
        weblinksData: action.payload,
      };
    }
  )
  .handleAction(
    loadLinks.failure,
    (state, action) => {
      return {
        ...state,
        weblinksData: [],
      };
    }
  );